import cogoToast from 'components/ToastMessage/ToastMessage';
import { ReactLeft, UI_STATES } from './uiStates/uiStates';

type ApiError = Error | CF.API.BaseResponse;

export const makeOnReactLeftError = (defaultReason: string) => {
  return (respL: ReactLeft): void => {
    const errorMessage = respL.props && respL.props.reason ? respL.props.reason : defaultReason;
    const errorTitle = respL.props && respL.props.title ? respL.props.title : 'Error';
    cogoToast.error(errorMessage, { heading: errorTitle });
  };
};

export const makeOnError = (defaultReason: string, title?: string) => {
  return (error: ApiError, _variables?: unknown, _context?: unknown): void => {
    const errorMessage = getReasonFromApiError(error) || defaultReason;
    const errorTitle = title || 'Error';
    cogoToast.error(errorMessage, { heading: errorTitle });
  };
};

const getReasonFromApiError = (err: ApiError): string => {
  if ('status' in err) {
    return err.status.details || '';
  }
  if ('message' in err) {
    return err.message || '';
  }
  return '';
};

export const apiErrorToReactLeft = (e: ApiError): ReactLeft =>
  ({ type: UI_STATES.error, props: { reason: getReasonFromApiError(e) || 'An error occurred, please try again.' } } as ReactLeft);
